/* ================================================================
   Herb Terra Premium Interactions
   Sticky ATC, scroll reveals, micro-interactions.
   ================================================================ */

(function() {
  'use strict';

  /* ── Scroll Reveal ──────────────────────────────────────────── */
  function initReveal() {
    var els = document.querySelectorAll('.htc-reveal');
    if (!els.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('htc-reveal--visible');
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15, rootMargin: '0px 0px -40px 0px' });

    els.forEach(function(el) { observer.observe(el); });
  }

  /* ── Sticky Add to Cart (Mobile) ────────────────────────────── */
  function initStickyATC() {
    var productForm = document.querySelector('.product-form');
    if (!productForm || window.innerWidth > 749) return;

    var title = document.querySelector('.product__title h1, .product__title .h1');
    var price = document.querySelector('.price-item--regular, .price-item--sale');
    if (!title || !price) return;

    // Sold-out detection. Dawn disables the real submit button exactly when the
    // variant is unavailable (buy-buttons.liquid); the OOS waitlist snippet also
    // hides .product-form__buttons. Either signal means do not offer "Add to Cart".
    var submitBtn = productForm.querySelector('.product-form__submit, [type="submit"]');
    var btnWrap = productForm.querySelector('.product-form__buttons');
    var soldOut =
      !submitBtn ||
      submitBtn.disabled ||
      submitBtn.hasAttribute('disabled') ||
      (btnWrap && getComputedStyle(btnWrap).display === 'none');

    // Where to route a sold-out shopper: the themed waitlist card or generic notify form.
    var waitlist = document.querySelector(
      '[data-mg-waitlist], [data-waitlist], section[class$="-wl"], .product-notify-me, [id*="Waitlist"], [id*="waitlist"]'
    );

    // Sold out with nowhere to send them: skip the bar rather than show a dead CTA.
    if (soldOut && !waitlist) return;

    // Pre-order is a normal add to cart with a different promise, so the label
    // comes from the form rather than living as a string in shared JS.
    var preorder = productForm.getAttribute('data-preorder') === 'true';
    var label = soldOut
      ? 'Join the waitlist'
      : (preorder ? (productForm.getAttribute('data-preorder-label') || 'Pre-order now') : 'Add to Cart');

    var sticky = document.createElement('div');
    sticky.className =
      'htc-sticky-atc' +
      (soldOut ? ' htc-sticky-atc--soldout' : '') +
      (preorder ? ' htc-sticky-atc--preorder' : '');
    sticky.innerHTML =
      '<div class="htc-sticky-atc__inner">' +
        '<div class="htc-sticky-atc__info">' +
          '<div class="htc-sticky-atc__title">' + title.textContent.trim() + '</div>' +
          '<div class="htc-sticky-atc__price">' + price.textContent.trim() + '</div>' +
        '</div>' +
        '<button class="htc-sticky-atc__btn" type="button">' + label + '</button>' +
      '</div>';
    document.body.appendChild(sticky);

    // The chat widget loads on its own schedule, so watch for it briefly
    // rather than assuming it is present at first paint.
    (function watchForChatLauncher() {
      var tries = 0;
      var timer = window.setInterval(function () {
        var launcher = document.getElementById('ht-launcher');
        if (launcher) {
          sticky.classList.add('htc-sticky-atc--chat-offset');
          window.clearInterval(timer);
        } else if (++tries > 20) {
          window.clearInterval(timer);
        }
      }, 400);
    })();

    sticky.querySelector('.htc-sticky-atc__btn').addEventListener('click', function() {
      if (soldOut) {
        waitlist.scrollIntoView({ behavior: 'smooth', block: 'center' });
        var email = waitlist.querySelector('input[type="email"]');
        if (email) setTimeout(function() { try { email.focus({ preventScroll: true }); } catch (e) {} }, 650);
        return;
      }
      var btn = productForm.querySelector('.product-form__submit, [type="submit"]');
      if (btn) btn.click();
    });

    var formObserver = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          sticky.classList.remove('htc-sticky-atc--visible');
        } else {
          sticky.classList.add('htc-sticky-atc--visible');
        }
      });
    }, { threshold: 0 });

    // When sold out, anchor visibility to the waitlist card so the bar hides while
    // the card is on screen and reappears once the shopper scrolls away from it.
    formObserver.observe(soldOut ? waitlist : productForm);
  }

  /* ── Comparison Table Row Stagger ───────────────────────────── */
  function initCompareReveal() {
    var rows = document.querySelectorAll('.htc-compare__table tbody tr');
    if (!rows.length) return;

    var observer = new IntersectionObserver(function(entries) {
      entries.forEach(function(entry) {
        if (entry.isIntersecting) {
          var rows = entry.target.querySelectorAll('tr');
          rows.forEach(function(row, i) {
            row.style.opacity = '0';
            row.style.transform = 'translateY(8px)';
            setTimeout(function() {
              row.style.transition = 'opacity 0.4s cubic-bezier(0.25,0.46,0.45,0.94), transform 0.4s cubic-bezier(0.25,0.46,0.45,0.94)';
              row.style.opacity = '1';
              row.style.transform = 'translateY(0)';
            }, i * 60);
          });
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.1 });

    var tbody = document.querySelector('.htc-compare__table tbody');
    if (tbody) observer.observe(tbody);
  }

  /* ── Init ────────────────────────────────────────────────────── */
  function init() {
    initReveal();
    initStickyATC();
    initCompareReveal();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
